import type { ResumeData } from '../../lib/types';
import { formatDate } from '../../lib/date';

export default function Employment({ data }: { data: ResumeData }) {
  const companies = data.employment?.companies ?? [];
  return (
    <section className="container-fluid">
      <h2>Employment</h2>
      {companies.map((company, ci) => (
        <div key={ci}>
          <div className="row">
            <div
              className="col-sm-6 company-name"
              dangerouslySetInnerHTML={{ __html: company.name }}
            />
            <div className="col-sm-6 text-right company-location">{company.location}</div>
          </div>
          {company.positions.map((position, pi) => (
            <div key={pi}>
              <div className="row">
                <div className="col-sm-6 company-title">
                  <u>{position.title}</u>
                </div>
                <div className="col-sm-6 text-right title-dates">
                  <em>
                    {formatDate(position.dates.from)} - {formatDate(position.dates.to)}
                  </em>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <ul>
                    {position.description.map((d, di) => (
                      <li key={di} dangerouslySetInnerHTML={{ __html: d }} />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}
